var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSettingsIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 3H21.0003C21.8344 3 22.5 3.67157 22.5 4.5C22.5 5.3342 21.8286 6 21.0003 6H15V3ZM15 13.5H2.99632C2.16947 13.5 1.5 12.8284 1.5 12C1.5 11.1658 2.16992 10.5 2.99632 10.5H15V13.5ZM2.99843 3H6V6H2.99843C2.16399 6 1.5 5.32843 1.5 4.5C1.5 3.6658 2.17087 3 2.99843 3ZM10.5 1.5C12.1575 1.5 13.5 2.8425 13.5 4.5C13.5 6.1575 12.1575 7.5 10.5 7.5C8.8425 7.5 7.5 6.1575 7.5 4.5C7.5 2.8425 8.8425 1.5 10.5 1.5ZM19.5 9C21.1575 9 22.5 10.3425 22.5 12C22.5 13.6575 21.1575 15 19.5 15C17.8425 15 16.5 13.6575 16.5 12C16.5 10.3425 17.8425 9 19.5 9ZM4.5 16.5C6.1575 16.5 7.5 17.8425 7.5 19.5C7.5 21.1575 6.1575 22.5 4.5 22.5C2.8425 22.5 1.5 21.1575 1.5 19.5C1.5 17.8425 2.8425 16.5 4.5 16.5ZM9 21V18H21.0037C21.8301 18 22.5 18.6658 22.5 19.5C22.5 20.3284 21.8305 21 21.0037 21H9Z",
    fill: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettingsIcon);
export default __webpack_public_path__ + "static/media/settingsIcon.83b01c21015880c64488e3cc3626c99f.svg";
export { ForwardRef as ReactComponent };